<template>
  <v-dialog v-model="localShow" persistent width="300">
    <v-card color="background">
      <v-card-text>
        <p class="pt-3 d-flex justify-center">Connecting...</p>
        <v-progress-linear
            indeterminate
            color="green"
            class="mb-0"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "loading",
  props: {
    showLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    localShow: false
  }),
  watch: {
    showLoading(val) {
      this.localShow = val
    }
  }
}
</script>